export default `
.tile-aspect-ratio {
    width: 50%;
    float: left;
}

@media (min-width: 440px) {
  .tile-aspect-ratio {
    width: calc(100% / 3);
  }
}

@media (min-width: 600px) {
  .tile-aspect-ratio {
    width: calc(100% / 4);
  }
}

// breaks to large-format layout here

@media (min-width: 800px) {
  .tile-aspect-ratio {
    width: calc(100% / 3);
  }
}

@media (min-width: 1000px) {
  .tile-aspect-ratio {
    width: calc(100% / 4);
  }
}

@media (min-width: 1200px) {
  .tile-aspect-ratio {
    width: calc(100% / 5);
  }
}

@media (min-width: 1400px) {
  .tile-aspect-ratio {
    width: calc(100% / 6);
  }
}

@media (min-width: 1600px) {
  .tile-aspect-ratio {
    width: calc(100% / 7);
  }
}

@media (min-width: 1800px) {
  .tile-aspect-ratio {
    width: calc(100% / 8);
  }
}
`;



// WEBPACK FOOTER //
// ./src/components/Tiles/tileLegacyStyles.js